<template>
  <div>

    <!-- 타이틀 -->
    <dl class="header-title">
      <dt>
        <button v-if="this.$route.path === '/Receipt' || this.$route.path === '/receiptInfo'" @click="$router.push('/Main')"><i class="uil uil-angle-left-b"></i></button>
        <button v-else v-on:click="$router.go(-1)"><i class="uil uil-angle-left-b"></i></button>
      </dt>
      <dd>{{$route.meta.title}}</dd>
      <dt>
<!--        <button class="header-home-btn" v-on:click="$router.push('/Main')"></button>-->
      </dt>
    </dl>
    <div style="height: 44px;"></div>
    <!-- 타이틀 끝 -->

  </div>
</template>

<script>
export default {
  name: 'Header',
  methods: {
    barcodeOpen: function () { 
      document.getElementById("barcodeArea").style.right = "0px";
      document.getElementById("barcodeBg").style.display = "block";
    },
  },
}
</script>